import { validateUpload } from './sanitizeFilename';

/** One extension list shared by the admin picker and pre-upload validation. */
export const CONTENT_ATTACHMENT_ACCEPT =
  '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.csv,.txt,.md,.json,.zip,.png,.jpg,.jpeg';
export const CONTENT_ATTACHMENT_MAX_BYTES = 50 * 1024 * 1024;
export const CONTENT_ATTACHMENTS_BUCKET = 'content-attachments';

export function validateContentAttachment(file: File) {
  const result = validateUpload(file, { maxBytes: CONTENT_ATTACHMENT_MAX_BYTES });
  if (!result.ok) return result;
  const dot = file.name.lastIndexOf('.');
  const ext = dot >= 0 ? file.name.slice(dot).toLowerCase() : '';
  if (!CONTENT_ATTACHMENT_ACCEPT.split(',').includes(ext)) {
    return { ok: false as const, error: 'Formato no permitido para adjuntos.' };
  }
  return result;
}

export function formatBytes(bytes?: number | null): string {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
